/**
  * Archivo: request-cfdi-timbrar.model.tsx
  *   Autor: Jahaziel Jeuh Baltazar Isidoro <jahaziel.baltazar@finalsoft.com.mx>
  *   Fecha: Septiembre 19, 2023.
  */
export default class requestCFDITimbrar {
  public razonSocial: string = '';
  public rfc: string = '';
  public regimenFiscal?: requestCFDITimbrarRegimenFiscal;
  public codigoPostal: string = '';
  public pais?: requestCFDITimbrarPais;
  public estado?: requestCFDITimbrarEstado;
  public municipio:requestCFDITimbrarMunicipio = new requestCFDITimbrarMunicipio();
  public colonia?: requestCFDITimbrarColonia;
//  public colonia?: string = '';
  public calle: string = '';
  public numeroInterior:string = '';
  public numeroExterior: string = '';
  // public lada: string = '';
  public telefono: string = '';
  public extension: string = '';
  public usoCFDI?: requestCFDITimbrarCFDI;
}
class requestCFDITimbrarPais {
  public claveSat: string = '';
  public nombre: string = '';
}
class requestCFDITimbrarEstado {
  public id: number = 0;
  public claveSat: any = null;
  public nombre: string = '';
}
class requestCFDITimbrarMunicipio {
  public id:any = null;
  public claveSat:any = null;
  public nombre:string = '';
}
class requestCFDITimbrarColonia {
  public id:any = null;
  public claveSat:any = null;
  public nombre:string = '';
}
class requestCFDITimbrarCFDI {
  public claveSat: string = '';
  public descripcion: string = '';
}
class requestCFDITimbrarRegimenFiscal {
  public claveSat: string = '';
  public descripcion: string = '';
}
